import {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import PlbyHierarchicalPopup from "../reports/PlbyHierarchicalPopup";

export default function Plbyhierarchicalpopuppage() {
    const { transid } = useParams();
    const [record, setRecord] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
    if (!transid) return; // router may provide undefined briefly

    const fetchRecord = async () => {
      try {
        console.log("transid in popup page:", transid);
        // note single slash and correct endpoint
        const response = await axiosInstance.get(`/master/plby-hierarchical/${transid}`);
        console.log("Response in popup page:", response.data);
        setRecord(response.data);
      } catch (error) {
        console.error("Error fetching record:", error);
      }
    };

    fetchRecord();
  }, [transid]);

  return (
    <>
      {record && <PlbyHierarchicalPopup data={record} />}
    </>
  );
}
